(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/change-password/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/change-password/constants.js');

const FORMS = {
  HEADER: 'Byt lösenord',
  INFO_ONE_TIME_PASSWORD: 'Du har loggat in med ett tillfälligt lösenord. För att fortsätta använda tjänsten så behöver du byta lösenord.',
  PASSWORD_OLD: {
    LABEL: 'Nuvarande lösenord',
    REQUIRED_ERROR: 'Du måste ange ditt lösenord',
    NAME: 'oldPassword'
  },
  PASSWORD: {
    LABEL: 'Nytt lösenord',
    REQUIRED_ERROR: 'Du måste ange ditt lösenord',
    NAME: 'password',
    HELP: 'Använd 8-18 tecken, varav minst en bokstav och en siffra. Tillåtna tecken: 0-9 a-z A-Z.@-'
  },
  PASSWORD_REPEAT: {
    LABEL: 'Upprepa nytt lösenord',
    REQUIRED_ERROR: 'Du måste skriva samma lösenord två gånger',
    NAME: 'repeatPassword',
    HELP: 'Använd 8-18 tecken, varav minst en bokstav och en siffra. Tillåtna tecken: 0-9 a-z A-Z.@-'
  },
  BUTTON_CANCEL_LABEL: 'Avbryt',
  BUTTON_CONFIRM_LABEL: 'Bekräfta',
  INVALID_PASSWORD_ERROR_MESSAGE: 'Ogiltigt lösenord: Minst 8 tecken, minst 1 bokstav och 1 siffra. Tillåtna tecken 0-9 a-Z.@-',
  PASSWORD_NOT_MATCHING_ERROR_MESSAGE: 'Lösenorden matchar inte',
  PASSWORD_UPDATED_TITLE: 'Lösenordet uppdaterat',
  PASSWORD_UPDATED_MESSAGE: 'Ditt lösenord är nu uppdaterat.'
};
svs.ticket_partner.changePassword.constants = {
  FORMS
};


 })(window);